import React, { useRef, useEffect } from 'react'

// Probably a better way, but in order to provide 'timeshel.co/ios'
// in the 'refer friends' pre-loaded email content, we needed a path
// in this app. This component renders then immediately re-routes the
// browser to the intended destination -- our app on the App store

const Ios = () => {

  const linkRef = useRef(null)

  useEffect(() => linkRef.current.click())

  return (
    <a href='https://apps.apple.com/us/app/timeshel-monthly-photo-prints/id808417777' ref={ linkRef }> </a>
  )

}

export default Ios